/**
 * @fileoverview
 * Card Outter Component - Outer card wrapper
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card-outter',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-outter.component.html',
  styleUrl: './card-outter.component.css',
})
export class CardOutterComponent {
  @Input() cardClass: string = '';
}

